export { default } from "./RolePage";



// WEBPACK FOOTER //
// ./src/screens/Role/index.ts